import compose from '@aveneo/frontmoon-utils/lib/hocs/compose';
import { withRouter } from 'next/router';

import isAuthenticated from './isAuthenticated';
import connectContainer from './isAuthenticatedContainer';

export default compose(connectContainer, withRouter, isAuthenticated());
